import React from 'react';
import { CustomPageLoader, FormLayoutProps, ProtectedContainerProps, getPages as getPagesCore } from 'omni-package-react-core';
import Constants from '../../Constants';
import { MfaValidationPageProps } from '../MfaValidationPage';

const UsernameFormPage = () => <CustomPageLoader loader={() => import('../UsernameFormPage')} />;
const InvalidUsernameFormPage = () => <CustomPageLoader loader={() => import('../InvalidUsernameFormPage')} />;
const UsernameConfirmationPage = (props: { returnPage: string }) => <CustomPageLoader {...props} loader={() => import('../UsernameConfirmationPage')} />;
const SecurityQuestionsFormPage = () => <CustomPageLoader loader={() => import('../SecurityQuestionsFormPage')} />;
const SecurityQuestionsConfirmationPage = (props: { returnPage: string }) => <CustomPageLoader {...props} loader={() => import('../SecurityQuestionsConfirmationPage')} />;
const ChangePasswordFormPage = () => <CustomPageLoader loader={() => import('../ChangePasswordFormPage')} />;
const ChangePasswordConfirmationPage = (props: { returnPage: string }) => <CustomPageLoader {...props} loader={() => import('../ChangePasswordConfirmationPage')} />;
const MfaValidationPage = (props: MfaValidationPageProps) => <CustomPageLoader {...props} loader={() => import('../MfaValidationPage')} />;

const getPages = (
  ProtectedContainer: React.FC<ProtectedContainerProps>,
  isAuthenticated: boolean,
  FormLayout: React.FC<FormLayoutProps>,
  returnPage: string,
) => getPagesCore([
  {
    exact: true,
    path: Constants.UsernameFormSegment,
    component: (<FormLayout returnPage={returnPage} name="username-form" lob="corpo"><UsernameFormPage /></FormLayout>),
    protected: true,
  },
  {
    exact: true,
    path: Constants.UsernameConfirmationSegment,
    component: (<FormLayout returnPage={returnPage} name="username-confirmation" lob="corpo"><UsernameConfirmationPage returnPage={returnPage} /></FormLayout>),
    protected: true,
  },
  {
    exact: true,
    path: Constants.SecurityQuestionsFormSegment,
    component: (<FormLayout returnPage={returnPage} name="security-questions-form" lob="corpo"><SecurityQuestionsFormPage /></FormLayout>),
    protected: true,
  },
  {
    exact: true,
    path: Constants.SecurityQuestionsConfirmationSegment,
    component: (<FormLayout returnPage={returnPage} name="security-questions-confirmation" lob="corpo"><SecurityQuestionsConfirmationPage returnPage={returnPage} /></FormLayout>),
    protected: true,
  },
  {
    exact: true,
    path: Constants.ChangePasswordFormSegment,
    component: (<FormLayout returnPage={returnPage} name="change-password-form" lob="corpo"><ChangePasswordFormPage /></FormLayout>),
    protected: true,
  },
  {
    exact: true,
    path: Constants.ChangePasswordConfirmationSegment,
    component: (<FormLayout returnPage={returnPage} name="change-password-form-confirmation" lob="corpo"><ChangePasswordConfirmationPage returnPage={returnPage} /></FormLayout>),
    protected: true,
  },
  {
    exact: true,
    path: Constants.InvalidUsernameFormSegment,
    component: (<FormLayout canQuit={false} needHelp returnPage="/" name="invalid-username-form" lob="corpo"><InvalidUsernameFormPage /></FormLayout>),
    protected: true,
  },
  {
    exact: true,
    path: Constants.InvalidUsernameConfirmationSegment,
    component: (<FormLayout needHelp returnPage="/" name="invalid-username-confirmation" lob="corpo"><UsernameConfirmationPage returnPage="/" /></FormLayout>),
    protected: true,
  },
  {
    exact: true,
    path: `${Constants.MfaValidationSegment}/*`,
    component: (<MfaValidationPage returnPage={returnPage} FormLayout={FormLayout} />),
    protected: true,
  },
], ProtectedContainer, isAuthenticated, Constants.BasePageSegment);

export default getPages;
